:host {
  display: block;
}

#fileElem {
  display: none;
}

